import { CANADA_DOMAIN } from '../../translations'

export function getCurrency() {
  return location.hostname.endsWith(CANADA_DOMAIN) ? 'CAD' : 'USD'
}
